export type PaginationLimit = 25 | 50 | 100;

export const LIMIT_OPTIONS: PaginationLimit[] = [25, 50, 100];

const STORAGE_PREFIX = 'PAGINATION_LIMIT_';

/** The values reach localStorage, keep them stable. */
export enum PaginationScreenKey {
  ORDERS = 'orders',
  PRODUCTS = 'products',
  PRICING_DATA = 'pricingData',
  LABEL_PRINT = 'labelPrint',
  GENERATED_DOCUMENTS = 'generatedDocuments',
  PARTNER_SALES_ENTITIES = 'partnerSalesEntities',
  CARRIER_SETUP_ALLEGRO = 'carrierSetupAllegro',
  CARRIER_SETUP_ALZA = 'carrierSetupAlza',
  CARRIER_SETUP_KAUFLAND = 'carrierSetupKaufland',
}

export const DEFAULT_LIMIT: PaginationLimit = 25;

export const PRODUCTS_DEFAULT_LIMIT: PaginationLimit = 50;

export function isPaginationLimit(value: number): value is PaginationLimit {
  return LIMIT_OPTIONS.some(option => option === value);
}

export function getPaginationLimit(
  key: PaginationScreenKey,
  defaultLimit: PaginationLimit,
): PaginationLimit {
  const stored = Number(localStorage.getItem(STORAGE_PREFIX + key));

  return isPaginationLimit(stored) ? stored : defaultLimit;
}

export function savePaginationLimit(key: PaginationScreenKey, limit: PaginationLimit): void {
  localStorage.setItem(STORAGE_PREFIX + key, String(limit));
}
